























import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import Slide from '@/interfaces/models/Slide';

@Component
export default class PresentationSlideCard extends Vue {
  @Prop({ type: Object, required: true }) slide!: Slide;
  @Prop({ type: String }) order!: string;
  @Prop({ type: Boolean, default: false }) active!: boolean;

  get preview() {
    const { imageSet } = this.slide;
    return imageSet && imageSet.m;
  }
}
